/**
 * qr.tsx — QR Code 渲染组件
 *
 * 用途：BindTotpPage / AcceptInvitePage 渲染真实可扫的 otpauth:// 二维码。
 * 用成熟的 qrcode.react（QRCodeSVG）输出标准 SVG 二维码，Authenticator App / 通用扫码器可直接扫。
 * （原 353 行手写 ISO/IEC 18004 编码器有掩码/格式位 bug 致扫不出，已弃用换库。）
 */

import { QRCodeSVG } from 'qrcode.react';

interface QrCodeProps {
  /** 待编码内容（如 otpauth:// URI） */
  value: string;
  /** 像素尺寸，默认 136 */
  size?: number;
}

export function QrCode({ value, size = 136 }: QrCodeProps) {
  return (
    <QRCodeSVG
      value={value}
      size={size}
      level="M"
      marginSize={2}
      bgColor="#ffffff"
      fgColor="#000000"
    />
  );
}
